var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation"},[_c('Header'),_c('Banner',{attrs:{"src":_vm.src}}),_c('div',{staticClass:"operation_c m",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }